// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"f2a96fc1","532":"88a84d80"}[chunkId] + ".chunk.css";
};